import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { ApplyCloseEntityMemberCell } from "./ApplyCloseEntityMemberCell";

export const ApplyCloseEntityReviewerCell = memo(
    function ApplyCloseEntityReviewerCell({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        string
    >) {
        return (
            <ApplyCloseEntityMemberCell
                row={row}
                field="reviewerId"
                addText="Assign reviewer"
                emptyLabel="No reviewer"
            />
        );
    },
);
